import { render, staticRenderFns } from "./ClockEmployeeCardSvg.vue?vue&type=template&id=a93e8afc&"
import script from "./ClockEmployeeCardSvg.vue?vue&type=script&lang=js&"
export * from "./ClockEmployeeCardSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports